import React from 'react';
import '../../TaskManagement.css';
import { TbUser } from 'react-icons/tb';
import { ImManWoman } from 'react-icons/im';
import { GrUserFemale } from 'react-icons/gr';
import { GiTowel } from 'react-icons/gi'
import { FaPumpSoap, FaToiletPaper, FaTrash, FaBatteryQuarter } from 'react-icons/fa'
import { MdCleaningServices, MdWaterDrop, MdSignalWifiOff, MdAir } from 'react-icons/md'
import { FaTemperatureThreeQuarters } from 'react-icons/fa6'
import { HiExclamationCircle } from 'react-icons/hi2'


function TaskCard({ task, formatDateTime, onResolveClick, isSupervisor }) {
  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'Open':
        return 'status-open';
      case 'In Progress':
        return 'status-in-progress';
      case 'Resolved':
        return 'status-resolved';
      default:
        return '';
    }
  };

  const getWashroomIcon = (washroom) => {
    switch (washroom) {
      case 'Men':
        return <TbUser className="text-black" />;
      case 'Women':
        return <GrUserFemale className="text-black" />;
      case 'Unisex':
        return <ImManWoman className="text-black" />;
      default:
        return <ImManWoman className="text-black" />;
    }
  };

  const getTaskTypeIcon = (taskType) => {
    switch (taskType) {
      case 'Paper Towels Refill':
      case 'Paper Towel Refill':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-blue-200" aria-hidden="true">
            <GiTowel className="text-black" />
          </span>
        );
      case 'Liquid Soap Refill':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-cyan-200" aria-hidden="true">
            <FaPumpSoap className="text-black" />
          </span>
        );
      case 'Toilet Roll Refill':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-indigo-200" aria-hidden="true">
            <FaToiletPaper className="text-black" />
          </span>
        );
      case 'Empty Trash Bin':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-red-200" aria-hidden="true">
            <FaTrash className="text-black" />
          </span>
        );
      case 'Cleaning':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-green-200" aria-hidden="true">
            <MdCleaningServices className="text-black" />
          </span>
        );
      case 'Washroom Cleaning Required':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-orange-200" aria-hidden="true">
            <MdCleaningServices className="text-black" />
          </span>
        );
      case 'Temp Alert':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-rose-200" aria-hidden="true">
            <FaTemperatureThreeQuarters className="text-black" />
          </span>
        );
      case 'Humidity Alert':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-teal-200" aria-hidden="true">
            <MdWaterDrop className="text-black" />
          </span>
        );
      case 'Offline':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-gray-200" aria-hidden="true">
            <MdSignalWifiOff className="text-black" />
          </span>
        );
      case 'Faulty Readings':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-amber-200" aria-hidden="true">
            <HiExclamationCircle className="text-black" />
          </span>
        );
      case 'Battery Low':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-yellow-200" aria-hidden="true">
            <FaBatteryQuarter className="text-black" />
          </span>
        );
      case 'Air Quality Attention Required':
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-purple-200" aria-hidden="true">
            <MdAir className="text-black" />
          </span>
        );
      default:
        return (
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-full text-2xl washroom-inner-icon bg-gray-200" aria-hidden="true">
            <HiExclamationCircle className="text-black" />
          </span>
        );
    }
  };

  const getWashroomBg = (washroom) => {
    if (washroom === 'Women') return '#e9d4ff';
    if (washroom === 'Men') return '#b8e6fe';
    return undefined;
  };

  const canResolve = task.status === 'In Progress';

  // Due time, when the task carries one (kiosk-raised work orders stamp their
  // SLA on the alarm). Without it the deadline was only in the WhatsApp/email.
  const dueMs = task.dueAt ? new Date(task.dueAt).getTime() : NaN;
  const hasDue = Number.isFinite(dueMs) && task.status !== 'Resolved';
  const overdue = hasDue && Date.now() > dueMs;

  return (
    <div className="task-card">
      <div className="task-card-header">
        <span className={`task-status-badge ${getStatusBadgeClass(task.status)}`}>
          {task.status}
        </span>
        <span className="task-datetime">{formatDateTime(task.createdAt)}</span>
      </div>
      {hasDue && (
        <div className={`task-due${overdue ? ' task-due--overdue' : ''}`}>
          {overdue ? 'Overdue — was due ' : 'Due by '}{formatDateTime(task.dueAt)}
        </div>
      )}

      <div className="task-card-body">
        <div className="task-washroom">
          <span className="flex items-center justify-center min-h-9 min-w-9 max-h-9 max-w-9 text-gray-900 rounded-lg text-2xl washroom-icon" style={{ backgroundColor: getWashroomBg(task.washroom) }} aria-hidden="true">
            {getWashroomIcon(task.washroom)}
          </span>
          <span className="washroom-label">{task.washroomLabel}</span>
        </div>

        <div className="flex items-center justify-between gap-2">
          <h3 className="task-type">{task.type}</h3>
          {getTaskTypeIcon(task.type)}
        </div>

        {isSupervisor && task.assignee && (
          <div className="task-assigned-to">
            <span className="assigned-label">Assigned to:</span>
            <span className="assigned-name">{task.assignee}</span>
          </div>
        )}
      </div>

      {canResolve && (
        <div className="task-card-footer">
          <button className="task-resolve-btn" onClick={() => onResolveClick(task)}>
            Mark as Resolved
          </button>
        </div>
      )}
    </div>
  );
}

export default TaskCard;
